var render, staticRenderFns
import script from "./render-file.vue?vue&type=script&lang=js&"
export * from "./render-file.vue?vue&type=script&lang=js&"
import style0 from "./render-file.vue?vue&type=style&index=0&id=2ef94530&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports